import * as XLSX from 'xlsx';

export function exportUsersToXlsx(users, { getUserTypeLabel, getPermissionPills }) {
  if (!users?.length) return;

  const headers = ['Nome', 'E-mail', 'Status', 'Tipo', 'Permissões'];
  const rows = users.map((user) => [
    user.username || user.user?.split('@')[0] || '—',
    user.user || '—',
    user.active !== false ? 'Ativo' : 'Inativo',
    getUserTypeLabel(user),
    getPermissionPills(user).join(', ') || '—',
  ]);

  const ws = XLSX.utils.aoa_to_sheet([headers, ...rows]);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Usuários');
  const stamp = new Date().toISOString().slice(0, 10);
  XLSX.writeFile(wb, `usuarios-${stamp}.xlsx`);
}
